<script>
  import resources from './resources'

  export default {
    name: 'professional-staffs-form',
    mixins: [resources]
  }
</script>

<template lang="pug">
  page(title="Funcionário por Estabelecimento", icon="")
    .col-xs-12.content
      .container-fluid
        .row
          ul.nav.nav-tabs
            li
              router-link(:to="{name: 'professional.company.employees.index'}")
               a(href='#') Listagem
            li.active
              a Cadastro
          .col-xs-12.white-bg
            .row
              .col-xs-12
                div#serviceSupplierSpecialityForm.col-sm-10
                  h4 FUNCIONÁRIO &mdash; ESTABELECIMENTO
                  .form-group(style='margin-top:15px;')
                    .row
                      .form-group.col-sm-12.col-md-6.margin-bottom
                        v-input(:status="$v.employee.staff_id.$error ? 'error' : null")
                          f-select-user(label="Informe um nome de usuário",
                            v-model="employee.staff_id",
                            name="staff_id",
                            :searchable="true",
                            :errors="errors['staff_id']")
                      .form-group.col-sm-12.col-md-6.margin-bottom
                        v-input(:status="$v.employee.company_address_id.$error ? 'error' : null")
                          f-select-company-address(label="Local de Atendimento",
                             name="company_address_id",
                             v-model="employee.company_address_id",
                             :get-all="true",
                             :searchable="true",
                             :errors="errors['company_address_id']")

                  .buttons-wrapper
                    button.btn.save(@click.prevent="doAttach")
                      span.icon 
                      |  Associar Funcionário
</template>



// WEBPACK FOOTER //
// src/app/professional/company/employees/form/form.vue